<script setup lang="ts">
  import { onMounted, ref } from 'vue'

  import { useScreenSize } from '@/shared/lib'

  interface Props {
    fullscreen?: boolean
  }

  const props = defineProps<Props>()

  const images = import.meta.glob('@/assets/svg/hearts/*.svg', { eager: true })
  const imagePaths = Object.values(images).map((module) => (module as { default: string }).default)

  interface Heart {
    id: number
    size: number
    left?: number
    right?: number
    top: number // Добавляем top для более равномерного старта падения
    duration: number
    delay: number
    imageSrc: string
  }

  const hearts = ref<Heart[]>([])

  interface CreateParams {
    index: number
    isRightPart?: boolean
    isSecondWave?: boolean
  }

  const { isTablet } = storeToRefs(useScreenSize())

  const createHeart = ({ index, isRightPart = false, isSecondWave = false }: CreateParams) => {
    const config: Heart = {
      id: (index + 1) % 15,
      size: Math.random() * 20 + 20,
      top: isSecondWave ? 0 : Math.random() * 50,
      duration: Math.random() * 5 + 15,
      delay: Math.random() * 15,
      imageSrc: imagePaths[index % imagePaths.length]!,
    }
    if (isTablet.value) {
      config.size = Math.random() * 10 + 10
      config.left = Math.random() * 100

      return config
    }
    if (props.fullscreen) {
      config.left = Math.random() * 100
      return config
    }
    if (isRightPart) {
      config.right = Math.random() * 3
    } else {
      config.left = Math.random() * 25
    }

    return config
  }
  const createHeartsfall = (isSecondWave = false) => {
    for (let i = 0; i < 40; i++) {
      const heartConfig = {
        index: i,
        isSecondWave,
        isRightPart: i >= 25,
      }
      hearts.value.push(createHeart(heartConfig))
    }
  }

  onMounted(() => {
    const timeout = 8_000
    createHeartsfall()
    setTimeout(() => {
      createHeartsfall(true)
    }, timeout)
  })
</script>

<template>
  <div class="heartfall">
    <img
      v-for="heart in hearts"
      :key="heart.id"
      class="heart"
      :src="heart.imageSrc"
      :style="{
        width: `${heart.size}px`,
        height: `${heart.size}px`,
        left: heart.left ? `${heart.left}%` : 'auto',
        right: heart.right ? `${heart.right}%` : 'auto',
        top: `${heart.top}%`,
        animationDuration: `${heart.duration}s`,
        animationDelay: `${heart.delay}s`,
      }"
    />
  </div>
</template>

<style lang="scss" scoped>
  .heartfall {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
  }

  .heart {
    position: absolute;
    animation: fall linear infinite;
    opacity: 0;

    will-change: transform, opacity;
  }

  @keyframes fall {
    0% {
      transform: translateY(0) translateX(0);
    }
    5% {
      opacity: 1;
    }
    100% {
      transform: translateY(calc(100vh + 100px)) translateX(calc(10px - 15px * random()));
      opacity: 0;
    }
  }
</style>
